<template>
  <footer class="tab-footer">
    <div class="tab" v-for="tab in list" @click="tabChange(tab.key)" :class="{active: $route.name == tab.key}">
    	<div class="tab-main"><i class="footerico" :class="tab.icon"></i><span>{{tab.name}}</span></div>
    </div>
  </footer>
</template>
<script>
	export default {
		data() {
			return {
				list: [{
					key: 'mycourse',
					icon: 'footerico-mycourse',
					name: '课程表'
				}, {
					key: 'course',
					icon: 'footerico-course',
					name: '课程'
				}, {
					key: 'profession',
					icon: 'footerico-profession',
					name: '微专业'
				}, {
					key: 'center',
					icon: 'footerico-center',
					name: '我的'
				}]
			}
		},
		mounted() {},
		methods: {
			tabChange(name) {
				this.$router.push({
					name
				})
			}
		}
	}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.tab-footer {
		max-width: 1080px;
		color: #8E8E93;
		font-size: .24rem;
		background-color: #fff;
		display: flex;
		box-shadow: inset 0px 1px 0 rgba(212, 212, 217, .5);
	}
	
	.tab {
		padding: 0 0.1rem;
		text-align: center;
		flex: 1;
		display: flex;
		height: 1rem;
		box-sizing: border-box;
		text-align: center;
		align-items: center;
		justify-content: center;
	}
	
	.tab.active {
		color: #0B99FF;
	}
	
	.footerico {
		display: block;
		background: url(../../assets/images/footer_ico.png) no-repeat;
		background-size: 0.44rem 1.76rem;
		width: 0.44rem;
		height: 0.44rem;
		margin: 0 auto 0.04rem;
	}
	
	.tab.active .footerico {
		background-image: url(../../assets/images/footer_ico_h.png);
	}
	
	.footerico-mycourse {
		background-position: 0px -0.44rem;
	}
	
	.footerico-course {
		background-position: 0px 0;
	}
	
	.footerico-profession {
		background-position: 0px -0.88rem;
	}
	
	.footerico-center {
		background-position: 0px -1.32rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/basic/footer.vue